export const orderStatuses = {
  cancelled: 'cancelled',
  accepted: 'accepted',
  rejected: 'rejected',
}
